import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import FilterAndSortButton from 'components/FilterAndSortButton';
import FilterModal from 'components/FilterModal';
import { DropDown } from 'components/form/DropDown';
import LoanEstimatesDisclaimer from 'components/Disclaimer/LoanEstimateDisclaimer';
import { formatUSD } from 'helpers/money.helper';
import { formatNumberNoDecimals } from 'helpers/number';
import FilterOptionsButton from 'components/FilterOptionsButton/index';
import RadioAutoLoanList from './RadioAutoLoanList';
import ZeroState from 'components/ZeroState/ZeroState';

const AutoRefinanceMarketplaceOffersView = props => {
  const { topRefinanceOffer } = props;
  return (
    <>
      {props.refinanceOffers?.length > 0 ? (
        <>
          {!props.hideDisclaimer && (
            <Row fullWidth>
              <Disclaimer showPartnerText className="margB8" />
            </Row>
          )}

          <SectionContainer>
            {topRefinanceOffer && (
              <AutoRefinanceSavingsView
                averagePaymentSavings={topRefinanceOffer?.averagePaymentSavings}
                loanAmount={topRefinanceOffer?.loanAmount}
                partnerName={topRefinanceOffer?.provider?.partnerName}
                {...props}
              />
            )}
            <Row className="margB24">
              <Label typeHeader={'h3'} className="H4 m-text-20">
                Your options for refinancing your{' '}
                {props.currentLoanDetails?.name} auto loan
              </Label>
            </Row>
            <Row className="margB16">
              <AutoRefinanceFilterSwitch {...props} />
            </Row>
            <AutoRefinanceOffersView {...props} />
          </SectionContainer>
        </>
      ) : (
        <SectionContainer>
          <Row className="margB16">
            <AutoRefinanceFilterSwitch {...props} />
          </Row>
          <ZeroState />
        </SectionContainer>
      )}
      <FilterModal
        showModal={props.showModal}
        onCancelFilter={props.hideModal}
        onApplyFilter={props.onApplyFilter}
        onResetFilter={props.onResetFilter}
        isApplyFilterDisabled={props.isApplyFilterDisabled}
      >
        <FilterModalContent {...props} />
      </FilterModal>
    </>
  );
};

const AutoRefinanceSavingsView = ({
  averagePaymentSavings,
  loanAmount,
  partnerName,
  ...props
}) => {
  return (
    <FlexContainer className="flex-column margB24">
      <FlexContainer className="justify-between margLR48 m-margLR16">
        <Label className="text-14 bold">
          Your Maximum Estimated Monthly Savings*
        </Label>
        <FlexContainer className="flex-column m-margT6">
          <LoanEstimatesDisclaimer
            {...props}
            handleShowLoanEstimatesDisclaimer={
              props.handleShowLoanEstimatesDisclaimer
            }
          />
        </FlexContainer>
      </FlexContainer>
      <Row>
        <span className="text-28 bold inline m-block margR4">
          {formatUSD(formatNumberNoDecimals(averagePaymentSavings))}/Month
        </span>
        <span className="text-14">
          Your options for refinancing your{' '}
          <span className="bold">
            {formatUSD(formatNumberNoDecimals(loanAmount))} {partnerName}
          </span>{' '}
          auto loan
        </span>
      </Row>
    </FlexContainer>
  );
};

const AutoRefinanceFilterSwitch = props => {
  if (props.autoLoanAccounts?.length === 1) {
    return (
      <FilterOptionsButton
        type="singleOption"
        initialText={props.currentSortType}
        options={props.sortList}
        values={[]}
        onSortBy={props.onSortBy}
        prefix="Sort: "
      />
    );
  } else {
    return <FilterAndSortButton {...props} />;
  }
};

const FilterModalContent = ({ ...props }) => {
  return (
    <>
      <Row fullWidth>
        <Label className="Subtitle-1 margB8">Sort by</Label>
        <DropDown
          id="sort-by"
          list={props.sortList}
          value={props.currentSortType}
          onChange={e => props.setCurrentSortType(e)}
          label="Sort by"
          defaultValue={props.sortList[0]}
          placeholder="Sort by"
          fullWidth
        />
      </Row>
      <Row fullWidth>
        <Label className="Subtitle-1 margT24 margB16">Auto Loan</Label>
        <RadioAutoLoanList {...props} />
      </Row>
    </>
  );
};

const AutoRefinanceOffersView = ({ ...props }) => {
  if (props.refinanceOffersLoading) {
    return <PageLoadingMask />;
  } else {
    return (
      <Row>
        <FlexContainer className="flex-column">
          <StaticOfferContainer
            offerMetadataList={props.refinanceOffers}
            showComparison={true}
            currentLoanDetails={props.currentLoanDetails}
            termsPostfix={' mo.'}
            eventHandler={props.eventHandler}
            pagePosition={props.moduleName}
            modulePosition={props.modulePosition}
            {...props}
          />
        </FlexContainer>
        <FlexContainer className="justify-end">
          <LoanEstimatesDisclaimer
            {...props}
            handleShowLoanEstimatesDisclaimer={
              props.handleShowLoanEstimatesDisclaimer
            }
          />
        </FlexContainer>
      </Row>
    );
  }
};

export default AutoRefinanceMarketplaceOffersView;
